import React from 'react';
import { MBOData, OrdData } from '../~Utilities/Data';
import { Text, View, TouchableOpacity } from 'react-native';
import { FontInfo } from "../~Utilities/Constants";
import { TransactionType } from '../~Utilities/Rq';
import { MaterialCommunityIcons, Octicons } from '@expo/vector-icons';

/*   ====================================================================   */

const MBO_QTY_NO     = 0;
const MBO_ORDERS_NO  = 1;

/*   ====================================================================   */

export interface ITextMBO
{
  oMBOData  : MBOData | undefined;
  bindEvent : (onEvent    : (() => void), 
               bSubscribe : boolean) => void;
}

/*   ====================================================================   */

export interface ITextMBOState
{
  iSeqNo : number | undefined;
  iMode  : number;
}

/*   ====================================================================   */

export default class TextMBO extends React.Component<ITextMBO>
 {
  private oMBOData : MBOData | undefined = undefined;

  /*   -------------------------------------------------------------------   */

  UpdateData()
  {
  if (this.oMBOData)
    {    
    if (this.state.iSeqNo != this.oMBOData.iSeqNo)
      this.setState({iSeqNo: this.oMBOData.iSeqNo});
    }
  }

  /*   -------------------------------------------------------------------   */

  public SetMBO(oMBOData : MBOData | undefined)
  {
  this.oMBOData = oMBOData;

  if (this.oMBOData)
    {    
    this.setState({iSeqNo: this.oMBOData.iSeqNo});
    this.forceUpdate();
    }
  else
    {
    this.setState({iSeqNo: undefined});
    }

  }

  /*   -------------------------------------------------------------------   */
   
  constructor(props)
  {
  super(props);

  this.oMBOData = this.props.oMBOData;

  if (this.props.oMBOData)
    this.state = {iMode:MBO_QTY_NO, iSeqNo:this.props.oMBOData.iSeqNo};

  this.UpdateData = this.UpdateData.bind(this);
  this.SetMBO     = this.SetMBO.bind(this);
  }

  /*   -------------------------------------------------------------------   */

  componentDidMount() 
  {
  this.props.bindEvent(this.UpdateData, true);
  }

  /*   -------------------------------------------------------------------   */

  componentWillUnmount() 
  {
  this.props.bindEvent(this.UpdateData, false);
  }

  /*   -------------------------------------------------------------------   */

  state : ITextMBOState = {
      iSeqNo: undefined,
      iMode: MBO_QTY_NO
   }

   /*   -------------------------------------------------------------------   */

  render() 
  {
  if (this.state.iSeqNo == undefined)
    return(null);

  switch(this.state.iMode)
    {
    case MBO_ORDERS_NO:
      return(
        // <View style={{flexDirection:'column', backgroundColor:'transparent', alignItems:'center', justifyContent:'center'}}>
        <TouchableOpacity onPress={()=>{this.setState({iMode: this.state.iMode==1? 0:this.state.iMode+1}) }}
        style={{alignItems:'center', justifyContent:'center', backgroundColor:'transparent', borderRadius:25, minWidth:50, height:20, 
                margin:5, marginTop:6, flexDirection:'row'}}
        >
        
          
        <Text style={[FontInfo.appStyles.txt_bold, {color:this.oMBOData?.bBuy? FontInfo.sBuyText : FontInfo.sSellText}]}>{this.oMBOData && this.oMBOData.iOrdersBehind > 0? this.oMBOData.iOrdersBehind : ""}</Text>
        <MaterialCommunityIcons name="run" size={20} color={this.oMBOData?.bBuy? FontInfo.sBuyText : FontInfo.sSellText} />
        <Text style={[FontInfo.appStyles.txt_bold, {color:this.oMBOData?.bBuy? FontInfo.sBuyText : FontInfo.sSellText}]}>{this.oMBOData && this.oMBOData.iOrdersAhead > 0? this.oMBOData.iOrdersAhead : ""}</Text>
        <Octicons name="triangle-right" size={20} color={FontInfo.sLightGreen} />
        </TouchableOpacity>
        // <Text>Orders</Text>
        // </View>
        );
    case MBO_QTY_NO:
      return(
        // <View style={{flexDirection:'column', backgroundColor:'transparent', alignItems:'center', justifyContent:'center'}}>
        <TouchableOpacity onPress={()=>{this.setState({iMode: this.state.iMode==1? 0:this.state.iMode+1}) }}
        style={{alignItems:'center', justifyContent:'center', backgroundColor:'transparent', borderRadius:25, minWidth:50, height:20, 
                margin:5, marginTop:6, flexDirection:'row'}}
        >

        <Text style={[FontInfo.appStyles.txt_bold, {color:this.oMBOData?.bBuy? FontInfo.sBuyText : FontInfo.sSellText}]}>{this.oMBOData && this.oMBOData.iQtyBehind > 0? this.oMBOData.iQtyBehind : ""}</Text>
        <MaterialCommunityIcons name="run" size={20} color={this.oMBOData?.bBuy? FontInfo.sBuyText : FontInfo.sSellText} />
        <Text style={[FontInfo.appStyles.txt_bold, {color:this.oMBOData?.bBuy? FontInfo.sBuyText : FontInfo.sSellText}]}>{this.oMBOData && this.oMBOData.iQtyAhead > 0? this.oMBOData.iQtyAhead : ""}</Text>
        {/* <MaterialCommunityIcons name="arrow-right-bold" size={20} color={FontInfo.sGreen} /> */}
        <Octicons name="triangle-right" size={20} color={FontInfo.sLightGreen} />
        </TouchableOpacity>
        // <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground}]}>Qty</Text>
        // </View>
        );
    }
  }
}